import React from 'react';
import {StyleSheet, View} from 'react-native';
import {useTranslation} from 'react-i18next';

import {Icon} from '@/shared/ui/icons';
import {AppText} from '@/shared/ui/text';
import {spacing, useTheme} from '@/shared/ui/theme';

/**
 * A thin amber strip that clears the status bar, shown only while offline. Amber, not
 * red: being offline is "attention, you're seeing saved data", not a failure — the same
 * meaning amber carries everywhere in the Checkpoint Console.
 *
 * Presentational only: the parent (App) decides when it mounts and hands it the top
 * safe-area inset to clear. When it mounts, App also zeroes the top inset for the
 * navigator below, so the header sits flush under this strip instead of leaving a gap.
 */
const styles = StyleSheet.create({
  bar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing(2),
    paddingBottom: spacing(2),
  },
});

export function OfflineBanner({topInset}: {topInset: number}) {
  const {t} = useTranslation();
  const p = useTheme();
  return (
    <View
      accessibilityRole="alert"
      style={[
        styles.bar,
        {backgroundColor: p.warningSoft, paddingTop: topInset + spacing(2)},
      ]}>
      <Icon name="warning" size={14} color={p.warning} />
      <AppText variant="caption" color={p.warningInk}>
        {t('offline.banner')}
      </AppText>
    </View>
  );
}
